<template>
  <div>
    <CommondLoading
      v-if="loadingModal"
      :loadingImage="dataLoading.inter"
      :show="loadingModal"
      :loadingText="loadingText"
    />
    <v-row>
      <v-col cols="4" v-if="rol != 'VALIDADORCC'">
        <v-btn
          outlined
          color="#00a7e4"
          block
          x-large
          :disabled="loadingModal"
          @click="handleCreateVentaPefai"
        >
          <h4>Nueva Venta</h4>
        </v-btn>
      </v-col>
      <v-col cols="4" v-if="rol != 'VALIDADORCC'">
        <v-btn
          outlined
          color="#00a7e4"
          block
          x-large
          :disabled="loadingModal"
          @click="handleOpenCurrentCotizacion"
        >
          <h4>Continuar cotización</h4>
        </v-btn>
      </v-col>
      <v-col cols="4" v-if="itsCurrentCotizacion && rol == 'VALIDADORCC'">
        <v-btn
          outlined
          color="#00a7e4"
          block
          x-large
          :disabled="loadingModal"
          @click="handleOpenCurrentCotizacion"
        >
          <h4>
            {{
              rol != "VALIDADORCC" || rol == "MANAGERCC"
                ? "Cotización"
                : "Emision validacion"
            }}
          </h4>
        </v-btn>
      </v-col>
      <v-col
        cols="4"
        v-if="(wasSeeditToPefai || isFromPefai) && rol != 'VALIDADORCC'"
      >
        <v-btn
          outlined
          color="#00a7e4"
          block
          x-large
          :disabled="loadingModal"
          @click="handleOpenCotizaciones"
        >
          <h4>Ver Cotizaciónes</h4>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dataLoading from "@/helpers/data/data-loading-gif.json";
import {
  createLeadPefai,
  createVentaPefai,
} from "@/services/leads/leads.service";

export default {
  components: {
    CommondLoading: () =>
      import("@/components/commonComponents/CommondLoading.vue"),
  },

  data() {
    return {
      dataLoading: dataLoading,
      loadingIframe: true,
      loadingModal: false,
      loadingText: "Cargando",
      rol: JSON.parse(localStorage.getItem("roles"))[0]?.rol || "",
    };
  },
  props: {
    isFromPefai: {
      type: Boolean,
      default: false,
    },
    wasSeeditToPefai: {
      type: Boolean,
      default: false,
    },
    needBeCreateInPefai: {
      type: Boolean,
      default: false,
    },
    origenUuidToPefai: {
      type: String,
      default: "",
    },
    leadID: {
      type: Number,
      default: 0,
    },
    origenIdToPefai: {
      type: String,
      default: "",
    },
    idPefaiOrigen: {
      type: String,
      default: "",
    },
  },
  methods: {
    async withLoading(action, loadingText) {
      this.loadingText = loadingText;
      this.loadingModal = true;
      try {
        return await action();
      } finally {
        this.loadingModal = false;
      }
    },
    frameLoaded() {
      this.loadingIframe = false;
    },
    frameError() {
      console.log("Error al cargar el iframe.");
    },
    async handleOpenCurrentCotizacion() {
      await this.withLoading(
        () => this.openCurrentCotizacion(),
        "Abriendo cotizacion",
      );
    },
    async handleOpenCotizaciones() {
      await this.withLoading(
        () => this.openCotizaciones(),
        "Abriendo cotizaciones",
      );
    },
    async handleCreateVentaPefai() {
      await this.withLoading(
        () => this.createVentaPefai(),
        "Creando nueva venta",
      );
    },
    async openNuevaCotizacion() {
      //Antes de crear la liga de nueva cotizacion tengo que checar si el lead necesita ser creado por primera vez en pefai
      var infolead = {
        origenLead:
          typeof this.$route.query.origenLeadUuid != "undefined"
            ? this.$route.query.origenLeadUuid
            : this.origenUuidToPefai,
        uuidlead: this.$route.params.uuid,
      };
      if (this.needBeCreateInPefai) {
        infolead = await this.createLead();
      }
      var numero_colaborador = localStorage.getItem("numero_colaborador");
      window.open(
        `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/cocheseguro/gateway/contratacion/${infolead.uuidlead}/${infolead.origenLead}/${numero_colaborador}`,
      );
      // window.open(
      //   `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/gateway/leads/${infolead.uuidlead}/${infolead.origenLead}/${numero_colaborador}`
      // );
    },
    openCurrentCotizacion() {
      var origenLead =
        this.$route.query.origenLeadUuid ?? this.origenUuidToPefai;
      var uuidlead = this.$route.params.uuid;
      var numero_colaborador = localStorage.getItem("numero_colaborador");
      let callCenter = localStorage.getItem("callCenter")
      if(callCenter){
        callCenter = JSON.parse(callCenter)
        console.log(callCenter?.nombre?.toString().toLocaleLowerCase());
        if(callCenter?.nombre?.toString().toLocaleLowerCase() === "gabssa"){
          window.open(
              `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/cocheseguro/gateway/contratacion/externo/${uuidlead}/${origenLead}/${numero_colaborador}/eci_venta_gabsa`,
          );
          return
        }
      }
      if (
        this.$route.query.llamadaValidador == "true" ||
        this.rol == "VALIDADORCC" ||
        this.rol == "MANAGERCC"
      ) {
        console.log(
          `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/traspaso/validador/auto/${
            this.idPefaiOrigen
          }/${(localStorage.getItem("agenteName") || "").replace(
            /\s+/g,
            "",
          )}/${localStorage.getItem("id")}`,
        );
        window.open(
          `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/traspaso/validador/auto/${
            this.idPefaiOrigen
          }/${(localStorage.getItem("agenteName") || "").replace(
            /\s+/g,
            "",
          )}/${localStorage.getItem("id")}`,
        );
      } else {
        window.open(
          `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/cocheseguro/gateway/contratacion/externo/${uuidlead}/${origenLead}/${numero_colaborador}/eci_venta`,
        );
      }
    },
    openCotizaciones() {
      //var origenLead = this.$route.query.origenLeadUuid
      var uuidlead = this.$route.params.uuid;
      var numero_colaborador = localStorage.getItem("numero_colaborador");
      window.open(
        `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/gateway/lista-cotizaciones/${uuidlead}/${numero_colaborador}`,
      );
    },
    async createLead() {
      var infolead = {
        origenLead: this.origenUuidToPefai,
        uuidlead: this.$route.params.uuid,
      };

      const leadCreado = await createLeadPefai(this.origenIdToPefai);
      if (!leadCreado.error) {
        this.$emit("leadCreadoPefai");
        return infolead;
      } else {
        this.$toast.error("Fallo al crear el lead en Pefai", {
          position: "top-right",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
    },
    async createVentaPefai() {
      try {
        const response = await createVentaPefai(this.origenIdToPefai);
        let pefaiResponse = JSON.parse(response.pefaiResponse);
        var uuidlead = this.$route.params.uuid;
        var numero_colaborador = localStorage.getItem("numero_colaborador");
        window.open(
          `${process.env.VUE_APP_URL_PEFAI_REDIRECT}/eci/cocheseguro/gateway/contratacion/${uuidlead}/${pefaiResponse.lead_id}/${numero_colaborador}`,
        );
      } catch (e) {
        this.$toast.error("Erro al crear lead con pefai");
        console.error(e);
      }
    },
  },
  computed: {
    itsCurrentCotizacion() {
      //Si no es un lead que esta en llamada y no es un lead que venga de pefai no tiene una cotizacion en curso
      return (
        (this.$route.query.llamadaMasiva === "true" && this.isFromPefai) ||
        this.$route.query.llamadaValidador == "true" ||
        this.rol == "VALIDADORCC" ||
        this.rol == "MANAGERCC"
      );
    },
  },
};
</script>

<style>
.card-loading {
  padding: 32px;
  max-width: 100%;
  min-height: 100px;
  display: flex; /* Usamos flexbox */
  justify-content: center; /* Centramos horizontalmente */
  align-items: center; /* Centramos verticalmente */
}
.center-image {
  margin: auto; /* Centro horizontal */
  display: block; /* Para que el margen automático funcione */
}
</style>
